export type DicaMockupId = 'urls' | 'email' | 'linksSuspeitos' | 'dadosSensiveis' | 'pagamentos' | 'areaCliente';

export interface OfficialUrl {
  label: string;
  url: string;
}

export interface DicaCard {
  title: string;
  description: string;
  officialUrls?: OfficialUrl[];
  mockup: DicaMockupId;
}

export const dicasCards: DicaCard[] = [
  {
    title: 'URLs oficiais CUB',
    description: 'As URLs oficiais da CUB sempre terminam em ".cub.com.br", como:',
    officialUrls: [
      { label: 'Área do Cliente', url: 'statement-viewer.cub.com.br' },
      { label: 'Visualizador de Cobranças', url: 'billingviewer.cub.com.br' },
    ],
    mockup: 'urls',
  },
  {
    title: 'Remetente dos e-mails',
    description: 'Todo e-mail da CUB sai sempre do mesmo remetente oficial: naoresponda@cub.com.br.',
    mockup: 'email',
  },
  {
    title: 'Links suspeitos',
    description: 'Não clique em links que pareçam estranhos ou de origem duvidosa recebidos por e-mail, SMS ou WhatsApp.',
    mockup: 'linksSuspeitos',
  },
  {
    title: 'Dados sensíveis',
    description: 'A CUB nunca pede senha, código de verificação ou dados sensíveis por e-mail, telefone ou WhatsApp.',
    mockup: 'dadosSensiveis',
  },
  {
    title: 'Pagamentos',
    description: 'A CUB nunca envia PDFs de boleto ou códigos Pix nas comunicações por e-mail.',
    mockup: 'pagamentos',
  },
  {
    title: 'Área do Cliente',
    description:
      'A Área do Cliente, que reúne suas cobranças, pode ser acessada somente por meio de um dos canais de contato definidos por você.',
    mockup: 'areaCliente',
  },
];
